exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div#homeImageSlider {\n  width: 360px;\n  height: 320px;\n  background-color: red;\n  border-radius: 5px;\n  border-radius: 5px;\n  overflow: hidden;\n  position: relative;\n  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2); }\n  div#homeImageSlider ul {\n    margin: 0;\n    padding: 0;\n    list-style: none; }\n    div#homeImageSlider ul li {\n      border-radius: 5px;\n      display: none;\n      position: absolute;\n      left: 0;\n      top: 0;\n      overflow: hidden; }\n      div#homeImageSlider ul li:first-child {\n        display: block; }\n      div#homeImageSlider ul li img {\n        width: 360px;\n        height: 320px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/home/evuslider/evuslider.component.scss
// module id = ../../../../../src/app/home/evuslider/evuslider.component.scss
// module chunks = main